import { Injectable } from '@angular/core';
import { LoginResponse } from '../beans/LoginResponse';

@Injectable({
	providedIn: 'root'
})
export class StorageService {

	private PASSWORD_MESSAGE_KEY = 'passwordMessage';

	private LOGIN_RESPONSE_KEY = 'auth-info';

	constructor() { }

	// ==============================
	// GENERIC METHODS
	// ==============================

	set(key: string, value: any): void {
		try {
			const serialized = JSON.stringify(value);
			localStorage.setItem(key, serialized);
		} catch (e) {
			console.error('[StorageService] Error on set():', e);
		}
	}

	get<T>(key: string): T | null {
		try {
			const item = localStorage.getItem(key);
			if (!item) return null;
			return JSON.parse(item) as T;
		} catch (e) {
			console.error('[StorageService] Error on get():', e);
			return null;
		}
	}

	remove(key: string): void {
		localStorage.removeItem(key);
	}

	clear(): void {
		localStorage.clear();
	}

	// ==============================
	// LOGIN RESPONSE METHODS
	// ==============================

	setLoginResponse(loginResponse: LoginResponse): void {
		localStorage.setItem(this.LOGIN_RESPONSE_KEY, JSON.stringify(loginResponse));
	}

	getLoginResponse(): LoginResponse {
		const raw = localStorage.getItem(this.LOGIN_RESPONSE_KEY);

		if (!raw) {
			return new LoginResponse(); // 👈 празен, инициализиран обект
		}

		try {
			return Object.assign(new LoginResponse(), JSON.parse(raw));
		} catch (e) {
			console.warn('Invalid LOGIN_RESPONSE in storage, resetting', e);
			return new LoginResponse();
		}
	}

	removeLoginResponse(): void {
		localStorage.removeItem(this.LOGIN_RESPONSE_KEY);
	}

	// ==============================
	// PASSWORD MESSAGE METHODS
	// ==============================

	setPasswordMessage(msg: string): void {
		localStorage.setItem(this.PASSWORD_MESSAGE_KEY, msg);
	}

	getPasswordMessage(): string | null {
		return localStorage.getItem(this.PASSWORD_MESSAGE_KEY);
	}

	removePasswordMessage(): void {
		localStorage.removeItem(this.PASSWORD_MESSAGE_KEY);
	}

}
